module.exports = __webpack_public_path__ + "static/media/test5_4.7d65af2d.png";